import {
  type ForwardedRef,
  type KeyboardEvent,
  type MouseEvent,
  forwardRef,
} from 'react';

interface ButtonDivProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const ButtonDiv = forwardRef<HTMLDivElement, ButtonDivProps>(
  ( { children, onClick, ...restProps }, ref: ForwardedRef<HTMLDivElement> ) => {
    const handleKeyDown = ( e: KeyboardEvent<HTMLDivElement> ) => {
      if ( e.key === 'Enter' || e.key === ' ' ) {
        e.preventDefault();
        if ( onClick ) {
          onClick( e as unknown as MouseEvent<HTMLDivElement> );
        }
      }
    };

    return (
      <div
        ref={ref}
        onClick={onClick}
        tabIndex={0}
        // biome-ignore lint/a11y/useSemanticElements: <explanation>
        role="button"
        onKeyDown={handleKeyDown}
        {...restProps}
      >
        {children}
      </div>
    );
  }
);

ButtonDiv.displayName = 'ButtonDiv';
export default ButtonDiv;
